import { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { dashboardService } from '../../services/dashboard';

const PRESET_AMOUNTS = [10, 20, 50, 100];

export default function AddCreditsModal() {
  const navigate = useNavigate();
  const { feeRate, setMessage } = useOutletContext();
  const [creditAmount, setCreditAmount] = useState('20');
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const close = () => navigate('/billing/');

  const creditsNum = parseFloat(creditAmount) || 0;
  const chargeAmount = creditsNum * (1 + feeRate);
  const feeAmount = chargeAmount - creditsNum;

  const handleCheckout = () => {
    setCheckoutLoading(true);
    setMessage('');
    dashboardService.billingCheckout(
      { credits_usd: creditsNum },
      (res) => {
        setCheckoutLoading(false);
        if (res.data.checkout_url) {
          window.location.href = res.data.checkout_url;
        } else {
          setMessage(res.data.message || 'Stripe is not configured. Contact support.');
          close();
        }
      },
      (err) => {
        setCheckoutLoading(false);
        setMessage(err?.detail || 'Checkout failed');
        close();
      },
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl bg-theme-main border border-theme-secondary p-6 shadow-lg">
        <h2 className="text-lg font-medium mb-4">Buy credits</h2>
        <div className="flex flex-wrap gap-2 mb-4">
          {PRESET_AMOUNTS.map((amt) => (
            <button
              key={amt}
              type="button"
              onClick={() => setCreditAmount(String(amt))}
              className={`px-3 py-1.5 rounded-lg text-sm border transition-colors ${
                creditAmount === String(amt)
                  ? 'border-theme-primary bg-theme-primary/10 text-theme-primary'
                  : 'border-theme-secondary hover:border-theme-primary/40'
              }`}
            >
              ${amt}
            </button>
          ))}
        </div>
        <label className="text-sm opacity-60 block mb-1">Custom amount (USD)</label>
        <input
          type="number"
          min="5"
          max="10000"
          step="1"
          value={creditAmount}
          onChange={(e) => setCreditAmount(e.target.value)}
          autoFocus
          className="w-full rounded-lg border border-theme-secondary bg-theme-main px-3 py-2 text-sm mb-4"
        />
        <div className="text-xs opacity-50 mb-6 space-y-0.5">
          <div>Credits: <span className="font-medium opacity-80">${creditsNum.toFixed(2)}</span></div>
          <div>Platform fee ({(feeRate * 100).toFixed(0)}%): <span className="font-medium opacity-80">${feeAmount.toFixed(2)}</span></div>
          <div>Total charge: <span className="font-medium opacity-80">${chargeAmount.toFixed(2)}</span></div>
        </div>
        <div className="flex justify-end gap-3">
          <button type="button" onClick={close} className="px-4 py-2 rounded-lg border border-theme-secondary text-sm">
            Cancel
          </button>
          <button
            type="button"
            onClick={handleCheckout}
            disabled={checkoutLoading || creditsNum < 5}
            className="px-4 py-2 rounded-lg bg-theme-primary text-theme-button text-sm font-medium disabled:opacity-40"
          >
            {checkoutLoading ? 'Redirecting…' : 'Add credits'}
          </button>
        </div>
      </div>
    </div>
  );
}
